import React from 'react';
import { SvgIcon } from 'ui/SvgIcon';
import ExclamationCircleIcon from 'ui/Icons/tabler/exclamation-circle.component.svg';

export const TravelPartnerPrivacyNote = React.memo(() => {
  return (
    <div className="travel-agent-privacy-note bg-brown-15 p-4 mb-25px">
      <div className="flex items-center gap-1">
        <span className="block text-brown-100 font-pt-sans text-base font-bold mb-1">Privacy</span>
        <SvgIcon IconComponent={ExclamationCircleIcon} className="block w-4 h-4 fill-brown-100" />
      </div>
      <span className="block font-pt-sans text-15px">
        NOTE: The <span className="italic">Travel Partner</span> linked to this booking will be able to see this
        data.
      </span>
    </div>
  );
});
